function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M116.9,28.8l-4.8,10.7l4.8,11.8c-1.4-0.2-2.8-0.4-4.2-0.6l-2.7-6.5l-2.7,6c-1.4-0.2-2.7-0.3-4-0.5l4.8-10.3 l-4.4-10.6h4l2.5,5.9l2.6-5.9H116.9z M96.8,49.2c1.2,0.1,2.5,0.1,3.7,0.3V28.8h-3.7V49.2z M87.2,45.2c2.1,0,4.3,0.2,6.4,0.3v3.5 c-3.3-0.2-6.7-0.4-10.1-0.5V28.8h3.7V45.2z M74.4,36.8h5.1v3.5h-5.1v8h-3.7V28.8h10.5v3.5h-6.8V36.8z M68.3,32.3h-3.9v16.2 c-1.3,0-2.5,0-3.7,0V32.3h-3.9v-3.5h11.5V32.3z M47.7,37c1.5,0,3.7-0.1,5-0.1v3.5c-1.7,0-3.6,0-5,0.1v5.2c2.2-0.1,4.4-0.3,6.6-0.4 v3.4L44,49.5V28.8h10.4v3.5h-6.6V37z M40.3,49.8c-1.3,0.2-2.7,0.3-4.1,0.5l-4.3-11.8v12.3c-1.3,0.1-2.6,0.3-3.8,0.5V28.8h3.6 l4.9,12.8V28.8h3.8V49.8z"
});

var SvgLogoNetflix = function SvgLogoNetflix(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 80",
    style: {
      enableBackground: "new 0 0 145 80"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/logo-netflix.4a84a928.svg";
export { SvgLogoNetflix as ReactComponent };